import {useMutation} from '@apollo/react-hooks';

import type {
    ClickTrackingDomainSet as ClickTrackingDomainSetMutation,
    ClickTrackingDomainSetVariables as ClickTrackingDomainSetMutationVariables,
    ClickTrackingDomainSetInput,
} from 'nutshell-graphql-types';

import SET_DOMAIN from '../mutations/click-tracking-domain-set.graphql';

export function useSetClickTrackingDomain(): {
    setClickTrackingDomain: (arg1: ClickTrackingDomainSetInput) => Promise<any>;
} {
    const [setClickTrackingDomain] = useMutation<
        ClickTrackingDomainSetMutation,
        ClickTrackingDomainSetMutationVariables
    >(SET_DOMAIN);

    return {
        setClickTrackingDomain: (input: ClickTrackingDomainSetInput) =>
            setClickTrackingDomain({
                variables: {input},
            }),
    };
}
